module.exports = __webpack_public_path__ + "assets/img/dishes3.1b988cef.png";